import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { ITEM_FRONEND_URL, NAME_FOR_UI } from "./ducks/actions";

function ItemMenu(props) {
  const { filmId, itemId } = props.match.params;
  const { item } = props;
  const invalidIds = ["add", "overview"];

  if (invalidIds.indexOf(itemId) > -1) {
    return null;
  }

  return (
    <div className="blade-menu menu">
      <p className="menu-label">{NAME_FOR_UI}</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/${ITEM_FRONEND_URL}/${itemId}/edit`}
            activeClassName="is-active">
            Edit {NAME_FOR_UI}
          </NavLink>
        </li>
        {item?.canAccessScenes &&
          <li>
            <NavLink
              to={`/films/${filmId}/${ITEM_FRONEND_URL}/${itemId}/scenes/`}
              activeClassName="is-active">
              Scenes
            </NavLink>
          </li>
        }
      </ul>
    </div>
  );
}

function mapStateToProps(state) {
  const { soundEffectsState } = state;
  return {
    item: soundEffectsState.item
  };
}

export default connect(mapStateToProps, {
})(ItemMenu);

